import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const MostUsedLanguages: React.FC = () => {
  const data = [
    { language: 'JavaScript', value: 27.484859280370504, fill: '#08306B' },
    { language: 'JAVA', value: 18.444959030993942, fill: '#08306B' },
    { language: 'Python', value: 16.467759173494834, fill: '#08519C' },
    { language: 'PHP', value: 11.400071250445315, fill: '#08519C' },
    { language: 'TypeScript', value: 9.05771286070538, fill: '#2171B5' },
    { language: 'C#', value: 5.7801923762023515, fill: '#2171B5' },
    { language: 'C++', value: 3.509084431777699, fill: '#4292C6' },
    { language: 'Bash', value: 2.8232988956180973, fill: '#4292C6' },
    { language: 'Kotlin', value: 2.6540790879942997, fill: '#6BAED6' },
    { language: 'C', value: 2.3779836123975775, fill: '#6BAED6' }
  ];

  return (
    <div>
      <StyledRecharts className="dark">
        <ResponsiveContainer height={400}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 40]}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default MostUsedLanguages;
